const CRUD = {
  data: () => ({}),
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    }
  },
  mounted() {},
  methods: {
    async save(validate = true) {
      if (validate && !this.$refs.form.validate()) return

      const options = await this.CreateOptions()

      this.$store
        .dispatch(options.action, options.object)
        .then(res => {
          if (res) this.$toast.success(this.$success)
          else this.$toast.error(this.$error)

          this.$eventBus.$emit("AddDialog", false)
        })
        .catch(err => {
          this.$toast.error(this.$error)
          this.$eventBus.$emit("AddDialog", false)
        })
    },
    async eliminar() {
      this.$store
        .dispatch(`${this.Store}/delete`, {
          id: this.MyObject[`id_${this.Store}`]
        })
        .then(res => {
          if (res) this.$toast.success(this.$success)
          else this.$toast.error(this.$error)

          this.$eventBus.$emit("DeleteDialog", false)
        })
        .catch(err => {
          this.$toast.error(this.$error)
          this.$eventBus.$emit("DeleteDialog", false)
        })
    },

    CreateOptions() {
      var options = {}

      if (this.MyIndex > -1) {
        options.action = `${this.Store}/update`
        options.object = Object.assign({}, this.MyObject)
        options.object.id = options.object[`id_${this.Store}`]
        delete options.object[`id_${this.Store}`]

        return options
      } else {
        options.action = `${this.Store}/insert`
        options.object = Object.assign({}, this.MyObject)

        if (this.Store == "associado") {
          var anos = Array.from(
            new Array(
              Number(this.$moment().year()) -
                Number(this.MyObject.ano_inicio) +
                1
            ),
            (x, i) => i + Number(this.MyObject.ano_inicio)
          )
          options.object.anos_pagos = anos.join(",")
          options.object.valores_pagos = anos
            .map(el => {
              return "0.00"
            })
            .join(",")
        }

        return options
      }
    }
  }
}

export default CRUD
